import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import {Container} from "@mui/material";
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import {DataGrid} from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel'
import Button from '@mui/material/Button';
import {isValidPhoneNumber} from 'libphonenumber-js';


const UserManagement = () => {

    const token = localStorage.getItem('token');

    const [rows, setRows] = useState([]);
    const [user, setUser] = useState({"Email": "", "FirstName": "", "LastName": "", "Password": "", "Phone": ""});
    const [anchorEl, setAnchorEl] = useState(null);
    const [adminIsChecked, setAdminIsChecked] = useState(false);
    const [activeIsChecked, setActiveIsChecked] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailHelperText, setEmailHelperText] = useState('');
    const [firstNameError, setFirstNameError] = useState(false);
    const [firstNameHelperText, setFirstNameHelperText] = useState('');
    const [lastNameError, setLastNameError] = useState(false);
    const [lastNameHelperText, setLastNameHelperText] = useState('');
    const [phoneError, setPhoneError] = useState(false);
    const [phoneHelperText, setPhoneHelperText] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [passwordHelperText, setPasswordHelperText] = useState('');

    const navigate = useNavigate();

    const columns = [
        //{ field: 'Id', headerName: 'ID', width: 70 },
        { field: 'Email', headerName: 'Email', width: 200 },
        { field: 'FirstName', headerName: 'First Name', width: 200 },
        { field: 'LastName', headerName: 'Last Name', width: 200 },
        { field: 'Phone', headerName: 'Phone', width: 150 },
        { field: 'Role', headerName: 'Admin', type: 'number', width: 60 },
        { field: 'NoLogins', headerName: 'Logins', type: 'number', width: 70 },
        { field: 'LastLogin', headerName: 'Last Login', width: 150 },
        { field: 'Active', headerName: 'Active', type: 'number', width: 60 },
    ];

    const paginationModel = { page: 0, pageSize: 10 };
    const open = Boolean(anchorEl);

    const getRowIdFromInternalId = (row) => row.Id;

    const handleRowClick = (params) => {
        console.log('Row id:', params.id);
        retrieveUserData(params.id);
    };

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const handleMenuLogout = () => {
        handleMenuClose();
        localStorage.setItem('token', "");
        localStorage.setItem('email', "");
        localStorage.setItem('x', "");
        navigate('/');
    }

    const handleMenuSearch = () => {
        handleMenuClose();
        navigate('/landing')
    }

    const handleMenuAbout = () => {
        handleMenuClose();
        navigate("/about")
    }

    const handleMenuProfile = () => {
        handleMenuClose();
        navigate("/profile")
    }

    const handleMenuAdvancedSearch= () => {
        handleMenuClose();
        navigate('/advancedSearch')
    }

    const handleAdminChange = (event) => {
        setAdminIsChecked(event.target.checked);
        setAdminChange(event.target.checked);
        console.log('Admin is checked:', event.target.checked);
    }

    const handleActiveChange = (event) => {
        setActiveIsChecked(event.target.checked);
        setActiveChange(event.target.checked);
        console.log('Active is checked:', event.target.checked);
    }

    const setAdminChange = (state)  => {
        if (state) {
            setUser(prevUser => ({
                ...prevUser,
                Role: 1,
            }));
        } else {
            setUser(prevUser => ({
                ...prevUser,
                Role: 0,
            }));
        }
    }

    const setActiveChange = (state)  => {
        if (state) {
            setUser(prevUser => ({
                ...prevUser,
                Active: 1,
            }));
        } else {
            setUser(prevUser => ({
                ...prevUser,
                Active: 0,
            }));
        }
    }

    const clearUser = () => {
        // Create a new object by spreading the existing user object
        // and overriding the 'name' property.
        setUser(prevUser => ({
            ...prevUser,
            Email: "",
            FirstName: "",
            LastName: "",
            Phone: "",
            Password: ""
        }));
        setEmailError(false);
        setEmailHelperText('');
        setFirstNameError(false);
        setFirstNameHelperText('');
        setLastNameError(false);
        setLastNameHelperText('');
        setPasswordError(false);
        setPasswordHelperText('');
        setPhoneError(false);
        setPhoneHelperText('');
    }

    const handleClear = () => {
        console.log("Clearing user state...");
        clearUser();
        setAdminIsChecked(false);
        setAdminChange(false);
        setActiveIsChecked(false);
        setActiveChange(false);
    }

    const handleEmailChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            Email: e.target.value,
        }));
    }

    const handleFirstNameChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            FirstName: e.target.value,
        }));
    }

    const handleLastNameChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            LastName: e.target.value,
        }));
    }

    const handlePhoneChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            Phone: e.target.value,
        }));
    }

    const handlePasswordChange = (e) => {
        setUser(prevUser => ({
            ...prevUser,
            Password: e.target.value,
        }));
    }

    const handleAddUser = () => {
        //console.log("Adding User...");
        var errors = false;

        if (validateEmail(user.Email)) {
            setEmailError(false);
            setEmailHelperText('');
            // Proceed with form submission logic (e.g., API call)
        } else {
            setEmailError(true);
            setEmailHelperText('Please enter a valid email address');
            errors = true;
        }
        if ( user.FirstName === '') {
            setFirstNameError(true);
            setFirstNameHelperText('First Name is required');
            errors = true;
        }
        if ( user.LastName === '') {
            setLastNameError(true);
            setLastNameHelperText('Last Name is required');
            errors = true;
        }
        if (validatePhone(user.Phone)) {
            setPhoneError(false);
            setPhoneHelperText('');
        } else {
            setPhoneError(true);
            setPhoneHelperText('Valid Phone Number is required');
            errors = true;
        }
        var passwordValidation = validatePassword(user.Password)
        console.log("PasswordValidation: " + passwordValidation)
        if (passwordValidation === '') {
            setPasswordError(false);
            setPasswordHelperText('');
        } else {
            setPasswordError(true);
            setPasswordHelperText(passwordValidation);
            errors = true;
        }
        setAdminChange(adminIsChecked);
        setActiveChange(activeIsChecked);
        if (!errors) {
            addUser(user);
        }
    }

    const handleModifyUser = () => {
        console.log('handleModifyUser...');
        var errors = false;

        if (validateEmail(user.Email)) {
            setEmailError(false);
            setEmailHelperText('');
            // Proceed with form submission logic (e.g., API call)
        } else {
            setEmailError(true);
            setEmailHelperText('Please enter a valid email address');
            errors = true;
        }
        if ( user.FirstName === '') {
            setFirstNameError(true);
            setFirstNameHelperText('First Name is required');
            errors = true;
        }
        if ( user.LastName === '') {
            setLastNameError(true);
            setLastNameHelperText('Last Name is required');
            errors = true;
        }
        if (validatePhone(user.Phone)) {
            setPhoneError(false);
            setPhoneHelperText('');
        } else {
            setPhoneError(true);
            setPhoneHelperText('Valid Phone Number is required');
            errors = true;
        }
        if (user.Password.length > 0 ) {
            var passwordValidation = validatePassword(user.Password)
            console.log('PasswordValidation: ', passwordValidation)
            if (passwordValidation === '') {
                setPasswordError(false);
                setPasswordHelperText('');
            } else {
                setPasswordError(true);
                setPasswordHelperText(passwordValidation);
                errors = true;
            }
        }
        setAdminChange(adminIsChecked);
        setActiveChange(activeIsChecked);
        if (!errors) {
            modifyUser(user);
        }
    }

    const handleDeleteUser = async () => {
        console.log('Deleting user id:', user.ID);
        const baseUrl = '/api/deleteUser';
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.append('userId', user.ID);
        const response  = await fetch(url,{
            method: 'DELETE',
            headers: {'Authorization': 'Bearer ' + token}
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json = await response.json();
        console.log('User data', json);
        clearUser();
        retrieveTableData();
    }

    const validateEmail = (email) => {
        // A simple regex for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    const validatePassword = (password) => {
        //console.log('Entering validatePassword:', password)
        const minLength = 8;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasLowerCase = /[a-z]/.test(password);
        const hasNumbers = /\d/.test(password);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

        if (password.length < minLength) {
            return 'Password length must be at least 8 characters'
        }
        if (!hasUpperCase) {
            return 'Password must include an upper case character'
        }
        if (!hasLowerCase) {
            return 'Password must include an lower case character'
        }
        if (!hasNumbers) {
            return 'Password must include a number character'
        }
        if (!hasSpecialChar) {
            return 'Password must include a special character: !@#$^&*(),.?":{}|<>'
        }
        return ''
    }

    const validatePhone = (phoneNo) => {
        return isValidPhoneNumber(phoneNo);
    }

    const addUser = async (user) => {
        console.log('Adding user');
        try {
            const response = await fetch('/api/addUser', {
                method: 'POST',
                headers: {'Authorization': 'Bearer ' + token},
                body: JSON.stringify(user),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Response: ', json);

        } catch (err) {
            console.error(err);
        }
        clearUser();
        retrieveTableData();
    }

    const modifyUser = async (user) => {
        console.log('Modifying user');
        try {
            const response = await fetch('/api/modifyUser', {
                method: 'POST',
                headers: {'Authorization': 'Bearer ' + token},
                body: JSON.stringify(user),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Response: ', json);

        } catch (err) {
            console.error(err);
        }
        clearUser();
        retrieveTableData();
    }

    const retrieveTableData = async () => {
        try {
            const response  = await fetch(`/api/getUsers`,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('User data', json);
            setRows(json);

        } catch (err) {
            console.error(err);
        }
    };

    const retrieveUserData = async (userId)  => {
        try {
            const baseUrl = '/api/getUser';
            const url = new URL(baseUrl, window.location.origin);
            url.searchParams.append('userId', userId);
            const response  = await fetch(url,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('User data', json);
            json['Password'] = "";
            setUser(json);
            console.log("JSON Role:", json['Role']);
            json['Role'] === 1 ? setAdminIsChecked(true) : setAdminIsChecked(false);
            console.log("JSON Active", json['Active']);
            json['Active'] ? setActiveIsChecked(true) : setActiveIsChecked(false);
        } catch (err) {
            console.error(err);
        }
    }


    useEffect(() => {
        retrieveTableData();
    }, []);
    return (
        <Container component="main" maxWidth="lg">
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            aria-haspopup="true"
                            aria-controls={open ? 'popup-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleMenuClick}
                        >
                            <MenuIcon />
                        </IconButton>
                        {/* The actual MUI Menu component */}
                        <Menu
                            id="popup-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            // Keep the menu mounted in the DOM when closed for potential performance benefits
                            // You can remove keepMounted if you prefer it to unmount
                            keepMounted
                            MenuListProps={{
                                'aria-labelledby': 'menu-button',
                            }}
                        >
                            {/* Menu Items */}
                            <MenuItem onClick={handleMenuAbout}>
                                <Typography variant="inherit">About</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuProfile}>
                                <Typography variant="inherit">Profile</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuSearch}>
                                <Typography variant="inherit">Search</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuAdvancedSearch}>
                                <Typography variant="inherit">Advanced Search</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuLogout}>
                                <Typography variant="inherit">Logout</Typography>
                            </MenuItem>
                        </Menu>

                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            User Management
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
            <Paper sx={{ height: 630, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowIdFromInternalId}
                    onRowClick={handleRowClick}
                    disableMultipleRowSelection={true}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5,10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                />
            </Paper>
            <Paper sx={{ flexGrow: 1, width: '100%', padding: 4, marginTop: 2}}>
                <Grid container spacing={2}>
                    <Grid size={4}>
                        <TextField
                            id="email"
                            label="Email"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.Email}
                            onChange={handleEmailChange}
                            error={emailError}
                            helperText={emailHelperText}
                            type="email"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="firstName"
                            label="First Name"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.FirstName}
                            onChange={handleFirstNameChange}
                            error={firstNameError}
                            helperText={firstNameHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="lastName"
                            label="Last Name"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.LastName}
                            onChange={handleLastNameChange}
                            error={lastNameError}
                            helperText={lastNameHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="password"
                            label="Password"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.Password}
                            onChange={handlePasswordChange}
                            error={passwordError}
                            helperText={passwordHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="phone"
                            label="Phone"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={user.Phone}
                            onChange={handlePhoneChange}
                            error={phoneError}
                            helperText={phoneHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={adminIsChecked}
                                    onChange={handleAdminChange}
                                    color="primary" // or 'secondary', 'success', etc.
                                />
                            }
                            label="Admin"
                        />
                        <FormControlLabel
                        control={
                            <Checkbox
                                checked={activeIsChecked}
                                onChange={handleActiveChange}
                                color="primary" // or 'secondary', 'success', etc.
                            />
                        }
                            label="Active"
                        />
                    </Grid>
                    <Grid size={3}>
                        <Button variant="contained" onClick={handleAddUser}>Add User</Button>
                    </Grid>
                    <Grid size={3}>
                        <Button variant="contained" onClick={handleModifyUser}>Modify User</Button>
                    </Grid>
                    <Grid size={3}>
                        <Button variant="contained" onClick={handleDeleteUser}> Delete User</Button>
                    </Grid>
                    <Grid size={3}>
                        <Button variant="contained" onClick={handleClear}>Clear</Button>
                    </Grid>
                </Grid>
            </Paper>
        </Container>

    );
};

export default UserManagement;